module.exports = __webpack_public_path__ + "img/video-10.7da28010.png";